class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.collapsedCount = parseInt(this.dataset.collapsedCount || '4', 10);
    this.toggle = this.querySelector('.product__description-toggle');
    this.list = this.querySelector('ul');
    this.init();
  }

  init() {
    // If there's no list or it has fewer items than the collapsed count, hide the toggle.
    if (!this.list) {
      this.dataset.toggleHidden = 'true';
      return;
    }
    const items = this.list.querySelectorAll(':scope > li');
    if (items.length <= this.collapsedCount) {
      this.dataset.toggleHidden = 'true';
      return;
    }

    // Start collapsed
    this.dataset.collapsed = 'true';
    if (this.toggle) {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.addEventListener('click', () => this.handleToggle());
    }
  }

  handleToggle() {
    const expanded = this.dataset.collapsed === 'true';
    if (expanded) {
      this.dataset.collapsed = 'false';
      this.toggle.setAttribute('aria-expanded', 'true');
    } else {
      this.dataset.collapsed = 'true';
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('product-description', ProductDescription);
